import { Box, Card, CardContent, IconButton, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import React, { useMemo } from "react";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useGetLeadSourceRate } from "../../hooks/data/data_dashboard";
import { useGetProjectState } from "../../hooks/data/data_project";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#FF8042", "#FF8042", "#FF8042", "#FF8042", "#FF8042"];

export const LeadSourceBoard: React.FC = () => {
    const { leadSourceRateArray, isLoadingLeadSourceRate } = useGetLeadSourceRate();
    const { projectStateArray, isLoadingProjectStateArray, refetchProjectState } = useGetProjectState();

    const handleHideLeadChart = () => {};

    const uniqueLeadNames = useMemo(() => {
        if (leadSourceRateArray) {
            const leadSet = new Set();
            leadSourceRateArray.forEach((entry) => {
                Object.keys(entry).forEach((key) => {
                    if (key !== "id" && key !== "name") leadSet.add(key);
                });
            });
            console.log(leadSet);
            return Array.from(leadSet);
        } else {
            return [];
        }
    }, [leadSourceRateArray]);

    return (
        <Card variant="outlined" sx={{ mt: 4 }}>
            <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Typography variant="h6" gutterBottom>
                        Lead-Quellen der Projekte
                    </Typography>
                    <IconButton size="small" onClick={handleHideLeadChart}>
                        <GridCloseIcon fontSize="small" />
                    </IconButton>
                </Box>
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={leadSourceRateArray} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        {uniqueLeadNames.map((lead, idx) => (
                            <Line
                                key={lead as string}
                                type="monotone"
                                dataKey={lead as string}
                                name={lead as string}
                                stroke={COLORS[idx % COLORS.length]}
                                activeDot={{ r: 8 }}
                            />
                        ))}
                    </LineChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
};
